import React from 'react';
import { Tooltip } from 'antd';
import type { Worker } from '@/types/Resolution886';
import * as S from './styles';

type BadgeType = Worker;

interface ListBadgesProps {
	badges: BadgeType[];
	color?: string;
}

const CountBadgeWithRef = React.forwardRef<HTMLDivElement, any>((props, _ref) => {
	const { ref: _, ...restProps } = props;
	return <S.CountBadge {...restProps} />;
});

export function ListBadges({ badges = [] }: Readonly<ListBadgesProps>): JSX.Element | null {
	const badgesArray = Array.isArray(badges) ? badges : [];

	if (!badgesArray || badgesArray.length === 0) {
		return null;
	}
	const firstBadge = badgesArray[0];
	const remainingCount = badgesArray.length - 1;

	const badgeName = firstBadge.name || firstBadge.label;

	return (
		<>
			<S.FirstBadge count={badgeName} style={{ marginRight: remainingCount > 0 ? '5px' : '0' }} />

			{remainingCount > 0 && (
				<Tooltip
					title={
						<div>
							{badgesArray.slice(1).map((badge) => (
								<div key={badge.id || badge.value}>{badge.name || badge.label}</div>
							))}
						</div>
					}
				>
					<CountBadgeWithRef count={`+${remainingCount}`} />
				</Tooltip>
			)}
		</>
	);
}
